import { VueComponent } from "../../../../../shared/types/VueComponent";
import {
  AutoReplyConditions,
  AutoReplyConditionTypeEnum
} from "../types";

export abstract class ConditionBuilder {
  abstract type: AutoReplyConditionTypeEnum
  abstract getModel(): AutoReplyConditions
  abstract view: VueComponent
}
